import * as clientFabric from 'fabric'

export let fabric = clientFabric

/**
 * Sets the fabric instance to the server side version.
 * This function is used to import the server side version of fabric
 * and set it as the global fabric instance.
 * @returns {Promise<void>} A promise that resolves when the fabric instance has been set.
 */
export const setServerFabric = async (): Promise<void> => {
  fabric = await import('fabric/node')
}
